import { useCrossFlow } from '@atlassiansox/cross-flow-support/trello';
import { isDesktop } from '@trello/browser';

import { useCrossFlowFor1PAds } from './experimental/useCrossFlowFor1PAds';
import { useCrossFlowForFunnelExperiment } from './experimental/useCrossFlowForFunnelExperiment';
import { reasonTypeDesktop, reasonTypeFallThrough } from './DisabledReasons';
import type { TouchpointSourceType } from './TouchpointSourceType';
import type { TrelloCrossFlow } from './TrelloCrossFlow';

// TODO export constant will all persistent sources
const persistentSources = ['atlassian-switcher'];

export const useTrelloCrossFlow: ({
  source,
  workspaceId,
}: {
  source: TouchpointSourceType;
  workspaceId?: string;
}) => TrelloCrossFlow = ({ source, workspaceId }) => {
  const crossFlow = useCrossFlow();
  const crossFlowFor1PAds = useCrossFlowFor1PAds({
    source,
    workspaceId,
  });
  const crossFlowFunnelExperiment = useCrossFlowForFunnelExperiment({
    source,
    workspaceId,
  });

  // Return early if crossFlow is disabled (missing context provider, incompatible version...)
  if (!crossFlow.isEnabled) {
    return crossFlow;
  }

  // Disable crossFlow on desktop due to compliance risks
  if (isDesktop()) {
    return {
      isEnabled: false,
      reason: reasonTypeDesktop,
    };
  }

  // Check if the current source is eligible for the funnel experiment
  if (crossFlowFunnelExperiment.isEnabled) {
    return crossFlowFunnelExperiment;
  }

  // Check if the current source is eligible for internal use
  if (crossFlowFor1PAds.isEnabled) {
    return crossFlowFor1PAds;
  }

  // Check if the current source matches a persistent crossFlow experience (not hidden behind a feature flag)
  if (persistentSources.includes(source)) {
    return {
      isEnabled: crossFlow.isEnabled,
      open: (options) => {
        if (options) {
          crossFlow.api.open({
            ...options,
          });
        }
      },
    };
  }

  return {
    isEnabled: false,
    reason: reasonTypeFallThrough,
  };
};
